export enum UserIdentitiesQueryKeys {
  Lookup = '/user-identities/lookup',
  Validate = '/user-identities/validate',
}
